import a from "react";
import { c as o } from "./app-a75c1d35.mjs";
import { u as R } from "./ImageContext-57256dc1.mjs";
import { i as t } from "./Image.module-8b345b58.mjs";
var g = /* @__PURE__ */ ((e) => (e.ARTICLE_QUOTE = "imageArticleQuote", e.HERO = "imageHero", e.CARD = "imageCard", e.PROMOTION = "imagePromotion", e.MASONRY_CARD = "imageMasonryCard", e.ARTICLE_PAGE_HERO = "imageArticlePageHero", e.PREVIEW_CARD = "imagePreviewCard", e.MAPBOX = "imageMapBox", e))(g || {});
function P({
  src: e,
  width: i,
  height: m,
  altText: n,
  imageLoader: c,
  styling: r,
  className: p,
  errorHandler: u,
  credits: A
}) {
  const C = R(), E = [n, A].filter(Boolean).join(" - ").trim() || "Image";
  return /* @__PURE__ */ a.createElement(
    "picture",
    {
      className: o(t.picture),
      itemProp: "image",
      itemScope: !0,
      itemType: "https://schema.org/ImageObject"
    },
    /* @__PURE__ */ a.createElement(
      C,
      {
        src: e,
        width: i,
        height: m,
        alt: E,
        loading: "lazy",
        loader: c,
        className: o(p, r ? t[r] : void 0),
        onError: u,
        itemProp: "contentUrl",
        quality: 100
      }
    )
  );
}
export {
  P as I,
  g as a
};
//# sourceMappingURL=Image-d6406817.mjs.map
